module.exports = __webpack_public_path__ + "static/media/pixel mall shot 04.e5a70535.webp";